import { createGlobalStyle } from 'styled-components';

const LightTheme = createGlobalStyle`
  body {
    --clientColor: #1423DC;
    --primaryColor: #1423DC;
    --addColor: #47d267;
    --itemHoverColor: var(--primaryColor);
    --componentBackground: #fff;
    --secondaryHover: var(--componentBackground);
    --subMenuBackground: var(--componentBackground);
    --menuDropdownBackground: var(--componentBackground);
    --pickerDropdown: var(--componentBackground);
    --primaryHover:  #e6f7ff;
    --secondaryColor: #ff4d4f;
    --disabledColor: #bfbfbf;
    --bodyBackground: #f0f2f5;
    --textColor: rgba(0, 0, 0, 0.65);
    --textColorSecondary: rgba(0, 0, 0, 0.45);
    --itemActiveBackground: #e6f7ff;
    --itemHoverBackground: #f0f0f0;
    --borderColor: #d9d9d9;
    --contrastBackground: #f5f5f5;
    --opacitySVG: 1;
    --primaryColorA04
    --primaryColorA07
    --primaryContrast
    --tabsGray
    --textColorInvert
    --textColorHover
    --textColorA015
    --textColorA075
    --borderColorA06
    --disabledColorA04
    --disabledColorA06
    --itemActiveColor
    --logo
    --logoSmall
    --errorColor
    --error100
    --errorA08
  }
`;

export default LightTheme;
